import { defineComponent, computed } from 'vue';
function clamp(n, min, max) {
    return Math.min(max, Math.max(min, n));
}
export default defineComponent({
    name: 'AColorSlider',
    props: {
        prefixCls: String,
        type: { type: String, required: true },
        value: { type: Number, required: true },
        color: String,
        disabled: Boolean,
    },
    emits: ['change', 'changeComplete'],
    setup(props, { emit }) {
        const percent = computed(() => {
            if (props.type === 'hue')
                return (props.value / 360) * 100;
            return props.value * 100;
        });
        const updateFromEvent = (e, complete) => {
            if (props.disabled)
                return;
            const target = e.currentTarget;
            const rect = target.getBoundingClientRect();
            const x = clamp((e.clientX - rect.left) / rect.width, 0, 1);
            const next = props.type === 'hue' ? x * 360 : x;
            emit('change', next);
            if (complete)
                emit('changeComplete', next);
        };
        const onMouseDown = (e) => {
            e.preventDefault();
            updateFromEvent(e);
            const onMove = (ev) => updateFromEvent(ev);
            const onUp = (ev) => {
                updateFromEvent(ev, true);
                window.removeEventListener('mousemove', onMove);
                window.removeEventListener('mouseup', onUp);
            };
            window.addEventListener('mousemove', onMove);
            window.addEventListener('mouseup', onUp);
        };
        return () => {
            const cls = `${props.prefixCls}-slider`;
            return (<div class={[cls, `${cls}-${props.type}`]} style={props.type === 'alpha'
                    ? {
                        background: `linear-gradient(to right, rgba(255,0,0,0), ${props.color || '#ff0000'})`,
                    }
                    : undefined} onMousedown={onMouseDown}>
          <div class={`${cls}-handler`} style={{ left: `${percent.value}%` }}/>
        </div>);
        };
    },
});
